<script>
    import { CornerItem } from '@/components'

    export let icon
    export let description
</script>

<CornerItem class="corner-item">
    <img class="icon" src={`./img/icons/${icon}.png`} />

    <div class="description">{description}</div>
</CornerItem>

<style lang="scss" module>
    .description {
        font-size: 18px;
        line-height: 23px;
        text-align: center;
        width: 292px;
    }

    .corner-item {
        .icon {
            display: block;
            margin: 0 auto;
            width: auto;
            height: 148px;
            margin-bottom: 38px;
        }
    }

    @media (max-width: 834px) {
        div.corner-item {
            width: calc((100% - 20px) / 2);
            height: 412px;
            margin-bottom: 20px;
        }
    }

    @media (max-width: 420px) {
        div.corner-item {
            width: 100%;
            height: 300px;
        }

        .icon {
            margin-bottom: 10px;
        }

        .description {
            font-size: 14px;
            line-height: 18px;
            padding: 0 25px;
        }
    }
</style>